// routes
import { PATH_MasterViewer } from '../../../routes/paths';
// components
import SvgColor from '../../../components/svg-color';
import AppCache from '../../../services/appcache';
// --------------------------------------------------------------------------------------------------------

const icon = (name) => (<SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />);

const ICONS = {
    dataUpload: icon('ic_dataupload'),
    dataMapping: icon('ic_mapping'),
    enablereupload: icon('ic_reupload'),
    master: icon('ic_master'),
    reprocess: icon('ic_reprocess'),
};

const userDetails = AppCache.GetUserLoginDetails();
const hasZylemFranchise = userDetails?.Franchise?.split(',')
    .some(f => f.trim().toUpperCase() === 'ETHICON' || f.trim().toUpperCase() === 'ENDO');

const navConfig = [
    //   GENERAL
    //   ----------------------------------------------------------------------
    {
        items: [
            {
                title: 'Masters', path: PATH_MasterViewer.master.root, icon: ICONS.master,
                children: [
                    { title: 'Distributor', path: PATH_MasterViewer.master.distributor },
                    { title: 'Products', path: PATH_MasterViewer.master.product },
                    { title: 'ECP Product', path: PATH_MasterViewer.master.ecpproduct },
                    { title: 'Standard Price', path: PATH_MasterViewer.master.standardpricemaster },
                    { title: 'Accounts', path: PATH_MasterViewer.master.account },
                    { title: 'Area Tree', path: PATH_MasterViewer.master.areatree },
                    { title: 'Surgeons', path: PATH_MasterViewer.master.surgeon },
                    { title: 'Employee', path: PATH_MasterViewer.master.empmaster },
                    { title: 'Territory', path: PATH_MasterViewer.master.territory },
                    { title: 'Employee Territory', path: PATH_MasterViewer.master.empterritory },
                    { title: 'Territory Management', path: PATH_MasterViewer.master.accountterritory },
                    { title: 'Branch Secretary Region', path: PATH_MasterViewer.master.empregion },
                    { title: 'Distributor Territory', path: PATH_MasterViewer.master.distributorterritory },
                    { title: 'Territory Hierarchy', path: PATH_MasterViewer.master.territoryhierarchy },
                    { title: 'Organization Group ', path: PATH_MasterViewer.master.orggroupdefinition },
                    { title: 'Dealer Agreement', path: PATH_MasterViewer.master.dealeragreementexpiry },
                    { title: 'Dealer Rating ', path: PATH_MasterViewer.master.dealerrating },
                    { title: 'Distributor Billing Software', path: PATH_MasterViewer.master.distributorbillingsoftware },
                    { title: 'Customer', path: PATH_MasterViewer.master.customers },
                    { title: 'Customer Account', path: PATH_MasterViewer.master.customeraccount },
                ],
            },
            {
                title: 'Allied Master', path: PATH_MasterViewer.alliedmaster.root, icon: ICONS.master,
                children: [
                    { title: 'Distributor Group', path: PATH_MasterViewer.alliedmaster.distributorgroup },
                    { title: 'UOM', path: PATH_MasterViewer.alliedmaster.uom },
                    { title: 'Franchise', path: PATH_MasterViewer.alliedmaster.franchise },
                    { title: 'Sub Franchise', path: PATH_MasterViewer.alliedmaster.subfranchise },
                    { title: 'Product Group', path: PATH_MasterViewer.alliedmaster.productgroup },
                    { title: 'Product category', path: PATH_MasterViewer.alliedmaster.productcategory },
                    { title: 'Product Brand', path: PATH_MasterViewer.alliedmaster.productbrand },
                    { title: 'Product Line', path: PATH_MasterViewer.alliedmaster.productline },
                    { title: 'Account Group', path: PATH_MasterViewer.alliedmaster.accountgroup },
                    { title: 'Account Type', path: PATH_MasterViewer.alliedmaster.accounttype },
                    { title: 'Account Classification', path: PATH_MasterViewer.alliedmaster.accountclassification },
                    { title: 'Account Segmentation', path: PATH_MasterViewer.alliedmaster.accountsegmentation },
                    { title: 'Account Category', path: PATH_MasterViewer.alliedmaster.accountcategory },
                    { title: 'Surgeon Contact Type', path: PATH_MasterViewer.alliedmaster.surgeoncontacttype },
                    { title: 'Surgeon Sub Contact Type', path: PATH_MasterViewer.alliedmaster.surgeonsubcontacttype },
                    { title: 'City Tier', path: PATH_MasterViewer.alliedmaster.citytier },
                    { title: 'Employee Level', path: PATH_MasterViewer.alliedmaster.emplevel },
                    { title: 'Specialist', path: PATH_MasterViewer.alliedmaster.specialist },
                    { title: 'Bravo Hierarchy', path: PATH_MasterViewer.alliedmaster.bravohierarchy },
                ],
            },
            { title: 'Data Upload Status', path: PATH_MasterViewer.dataUploadApprove, icon: ICONS.dataUpload },
            ...(hasZylemFranchise ? [
                { title: 'Reload Zylem Data', path: PATH_MasterViewer.reloadzylemdata, icon: ICONS.reprocess },
                { title: 'Data Mapping', path: PATH_MasterViewer.datamapping, icon: ICONS.dataMapping }
            ] : []),
            { title: 'Enable Reupload', path: PATH_MasterViewer.enablereupload, icon: ICONS.enablereupload },
            { title: 'Configuration', path: PATH_MasterViewer.configuration, icon: ICONS.master },
            // { title: 'System Configuration ', path: PATH_MasterViewer.cutoffdatepage, icon: ICONS.master },
            { title: 'System Configuration ', path: PATH_MasterViewer.franchisewisecutoff, icon: ICONS.master },
        ],
    }
];

export default navConfig;